<template>
  <div
    :class="[!isMobile || fixsize ? 'parentHistory' : 'parentHistoryMobile']"
  >
    <v-btn
      color="primary white--text"
      :class="[!isMobile || fixsize ? 'historyButton' : 'historyButtonMobile']"
      rounded
      @click="$emit('clicked')"
    >
      {{ title != null ? title : "مشاهده سوابق" }}
    </v-btn>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["title", "fixsize"],
  components: {
    appRow: DetailRow,
  },

  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
};
</script>
<style>
.historyButton {
  width: unset !important;
}
.historyButtonMobile {
  margin: 10px auto;
  margin-right: unset !important;
  width: 100% !important;
}

.parentHistory {
  display: inline-flex;
  padding: 20px 20px 20px 0;
}
.parentHistoryMobile {
  display: grid;
  padding: 10px 10px 0 30px;
}
</style>
